// @flow
import CreditCardExpirationDateInputFormGroupField from './CreditCardExpirationDateInputFormGroupField'
export default CreditCardExpirationDateInputFormGroupField
